import groq from 'groq';
import {
  useNextSanityImage,
  type UseNextSanityImageProps,
} from 'next-sanity-image';
import type { FC } from 'react';

import { sanityClientWithCdn } from '../../lib/sanity/sanityClient';
import type { LelandImage } from '../../types/cmsTypes';

import NextJSImage, { type NextJSImageProps } from './NextJSImage';

export const SANITY_IMAGE_PROJECTION = groq`asset->`;

type Props = Omit<
  NextJSImageProps,
  'placeholder' | 'blurDataUrl' | keyof UseNextSanityImageProps
> & {
  image: LelandImage;
};

const SanityImage: FC<Props> = ({ image, ...props }) => {
  const { width, height, ...sanityImageProps } = useNextSanityImage(
    sanityClientWithCdn,
    image,
  );

  return (
    <NextJSImage
      {...props}
      {...sanityImageProps}
      {...(props.fill ? {} : { width, height })}
      alt={props.alt}
      placeholder="blur"
      blurDataURL={image.asset.metadata.lqip}
    />
  );
};

export default SanityImage;

export const SanityImageHtml: FC<Props> = ({
  image,
  alt = '',
  sizes,
  ...props
}) => {
  const { width, height, loader, ...sanityImageProps } = useNextSanityImage(
    sanityClientWithCdn,
    image,
  );
  // eslint-disable-next-line @next/next/no-img-element
  return <img alt={alt} {...props} {...sanityImageProps} />;
};
